var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundbarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SoundbarLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 55,
    viewBox: "0 0 268 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2882",
    "data-name": "Group 2882",
    transform: "translate(33.748 10.056)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(0.252 -0.056)",
    fill: "#fed700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_7",
    "data-name": "Polygon 7",
    d: "M10.543,0,21.085,17.61H0Z",
    transform: "translate(29.427 7.53) rotate(90)",
    fill: "#0f0f0f"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(0 45)",
    fill: "#fed700",
    fontSize: 47,
    fontFamily: "HelveticaNeue, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "UNDBAR",
    transform: "translate(72 45)",
    fill: "#fed700",
    fontSize: 47,
    fontFamily: "HelveticaNeue, Helvetica Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "UNDBAR"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundbarLogo);
export default __webpack_public_path__ + "static/media/SoundbarLogo.05d3c5bd667cb41cc43a563d517683a7.svg";
export { ForwardRef as ReactComponent };